import React from 'react'
import { useSelector } from 'react-redux'
import Loader from './Loader'
const Detailphoto = () => {
      const movieDetails = useSelector((store)=> store.details.MovieDetails)
      const genres = movieDetails?.genres?.map((data)=>data.name)
      const strgenres = genres?.join(',') 
      const notadult = 'U/UA'
      const adult = 'A'
    return movieDetails === null ?  <Loader/> : (
    <div className="backdrop-blur-xl">
        <p className='text-yellow-300 font-bold text-base md:text-base '><span className='font-bold text-white '>Release Date :</span> {movieDetails?.release_date}</p>
        <p className='text-white text-base'> <span className='font-bold'>Genres : </span>{strgenres}</p>
        <p className='text-white text-base'><span className='font-bold'>Budget : </span> $ {movieDetails?.budget} </p>
        <p className='text-white text-base'><span className='font-bold'>BoxOffice : </span> $ {movieDetails?.revenue} </p>
        <p className='text-white text-base'><span className='font-bold'>Movie length : </span>  {movieDetails?.runtime} min </p>
        <p className='text-white text-base'><span className='font-bold'>Movie Certification : </span> {!movieDetails?.adult? notadult :adult} </p>
    </div>
  )
}

export default Detailphoto